import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  totalData: {},
  keyword: "",
  loading: false,
  loadingRegion: false,
  loadingArea: false,
  loadingOutlet: false,
  sortConfig: {
    key: "createdAt",
    direction: "ASC",
  },
  listRegion: [],
  listArea: [],
  listOutlet: [],
  listSegment: [],
  listObjectCategory: [],
};

export const RekapitulasiTemuan = createSlice({
  name: "rekapitulasiTemuan",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeLoadingRegion: (state, action) => {
      state.loading = action.payload;
    },
    ChangeLoadingArea: (state, action) => {
      state.loading = action.payload;
    },
    ChangeLoadingOutlet: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListRegion: (state, action) => {
      state.listRegion = action.payload;
    },
    ChangeListArea: (state, action) => {
      state.listArea = action.payload;
    },
    ChangeListOutlet: (state, action) => {
      state.listOutlet = action.payload;
    },
    ChangeListSegment: (state, action) => {
      state.listSegment = action.payload;
    },
    ChangeListObjectCategory: (state, action) => {
      state.listObjectCategory = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeTotalData,
  ChangeKeyword,
  ChangeLoading,
  ChangeLoadingRegion,
  ChangeLoadingArea,
  ChangeLoadingOutlet,
  ChangeSortConfig,
  ChangeListRegion,
  ChangeListArea,
  ChangeListOutlet,
  ChangeListSegment,
  ChangeListObjectCategory,
} = RekapitulasiTemuan.actions;

export default RekapitulasiTemuan.reducer;
